/* src/app/components/landing-page/landing-page.component.css */
p.ex1 {
  font-size: 28px;
  padding-top: 50px;
  color: var(--navy-600);
  text-align: center;
}
p.ex2 {
  font-size: 18px;
  padding-top: 20px;
  color: var(--navy-600);
  text-align: center;
}
/*# sourceMappingURL=landing-page.component.css.map */
